import React from "react";
import { Grid, TextField } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { ConfigPropExtenderHoc } from "../../../../../common/StaticConfigProvider";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";
import { ApplicationState } from "../../../../../store";
import AutocompleteField from "../../../../../common/formElements/AutocompleteField";
import { Mcc } from "../../../../../types";
import { isNil } from "ramda";
import { FormikProps, useFormikContext } from "formik";
import { Data } from "../../../../../store/terminal/types";

interface ConfigurationProps {
  labelTooltip: string;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

interface ConfigurationHocProps {
  labelTooltip: string;
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const ConfigurationHotCard = (props: ConfigurationHocProps) => {
  const { isUpdateAllowed, shouldHideField } = props;
  const formikProps = useFormikContext();
  const { values, setFieldValue } = formikProps as FormikProps<Data>;
  const { data } = useSelector(
    (state: ApplicationState) => state.hashedHotCard
  );
  const hashedHotCard = (data || []).map((item) => {
    return { label: item.attributes.Name, value: item.id }
  });
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <AutocompleteField
          key={`hashed-hotcard-list-${hashedHotCard.length}`}
          fieldname="attributes.HashedHotCard"
          options={hashedHotCard}
          value={hashedHotCard.find((item) => item.value === values.attributes.HashedHotCard)}
          onChange={(e, value) =>
            setFieldValue("attributes.HashedHotCard", !isNil(value) ? value.value : "")
          }
          renderInput={(params) => (
            <TextField {...params} label="Hashed Hot Card" variant="outlined" />
          )}
          disabled={!isUpdateAllowed}
        />
      </Grid>
    </Grid>
  );
};

const ConnectedConfigurationHotCard = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: ConfigurationHocProps) => {
    return {
      ...ownProps,
      shouldHideField: ownProps.shouldHideField,
    };
  }
)(ConfigurationHotCard);

const ConnectedConfigurationHotCardHoc = (props: ConfigurationProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedConfigurationHotCard {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedConfigurationHotCardHoc;
